export default __webpack_public_path__ + "static/pistola_maquinaria-c550275574a5fd7023a0df4a59b7b469.png";